import { render, staticRenderFns } from "./pickuplocation_mr.vue?vue&type=template&id=7629b3fe"
import script from "./pickuplocation_mr.vue?vue&type=script&lang=js"
export * from "./pickuplocation_mr.vue?vue&type=script&lang=js"
import style0 from "./pickuplocation_mr.vue?vue&type=style&index=0&id=7629b3fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports